'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var reactIntl = require('react-intl');
var moment = _interopDefault(require('moment'));
var utils = require('./utils.js');
var constants = require('./constants.js');
var styledComponents = require('./styled-components.js');
var RangeSelector = require('./components/RangeSelector.js');
var EndYearSelect = require('./components/EndYearSelect.js');
var StartYearSelect = require('./components/StartYearSelect.js');
var StartMonthSelect = require('./components/StartMonthSelect.js');
var EndMonthSelect = require('./components/EndMonthSelect.js');

var usePrevious = function (value) {
    var ref = React.useRef('');
    React.useEffect(function () {
        if (value)
            ref.current = value;
    });
    return ref.current;
};
var useCompare = function (val) {
    var prevVal = usePrevious(val);
    return prevVal !== val;
};
var DEFAULT_RANGE_CHOICE = '12';
var MonthYearRangePicker = function (props) {
    var reporter = props.reporter, preventSameStartEnd = props.preventSameStartEnd;
    var intl = reactIntl.useIntl();
    var fm = intl.formatMessage;
    var Translations = {
        date: fm({ id: "componentLib.monthYearRangePicker.date" }),
        start: fm({ id: "componentLib.monthYearRangePicker.start" }),
        end: fm({ id: "componentLib.monthYearRangePicker.end" }),
    };
    var startVals = utils.getStartValues(DEFAULT_RANGE_CHOICE);
    var _a = utils.getDefaultEndDateYear(), currentMonth = _a[0], currentYear = _a[1];
    var _b = React.useState(startVals.month), startMonth = _b[0], setStartMonth = _b[1];
    var _c = React.useState(startVals.year), startYear = _c[0], setStartYear = _c[1];
    var _d = React.useState(currentMonth), endMonth = _d[0], setEndMonth = _d[1];
    var _e = React.useState(currentYear), endYear = _e[0], setEndYear = _e[1];
    var _f = React.useState(DEFAULT_RANGE_CHOICE), rangeChoice = _f[0], setRangeChoice = _f[1];
    var _g = React.useState(false), debounce = _g[0], setDebounce = _g[1];
    var endMonthChanged = useCompare(endMonth);
    var startMonthChanged = useCompare(startMonth);
    var endYearChanged = useCompare(endYear);
    var startYearChanged = useCompare(startYear);
    var rangeChoiceChanged = useCompare(rangeChoice);
    React.useEffect(function () {
        if (!debounce &&
            (endMonthChanged ||
                startMonthChanged ||
                endYearChanged ||
                startYearChanged ||
                rangeChoiceChanged)) {
            setDebounce(true);
            var newStartMonth_1 = startMonth;
            var newStartYear_1 = startYear;
            if (preventSameStartEnd &&
                (moment(endMonth + " " + endYear, 'M YYYY').isBefore(moment(startMonth + " " + startYear, 'M YYYY')) ||
                    (endMonth === startMonth && endYear === startYear))) {
                newStartMonth_1 = moment(endMonth + " " + endYear, 'M YYYY')
                    .subtract(1, 'months')
                    .format('M');
                newStartYear_1 = moment(endMonth + " " + endYear, 'M YYYY')
                    .subtract(1, 'months')
                    .format('YYYY');
                setStartMonth(newStartMonth_1);
                setStartYear(newStartYear_1);
            }
            setTimeout(function () {
                reporter({
                    startMonth: startMonth,
                    endMonth: endMonth,
                    startYear: startYear,
                    endYear: endYear,
                    startDate: moment(newStartMonth_1 + " " + newStartYear_1, 'M YYYY')
                        .startOf('month')
                        .toDate(),
                    endDate: moment(endMonth + " " + endYear, 'M YYYY')
                        .endOf('month')
                        .toDate(),
                });
                setDebounce(false);
            }, 200);
        }
    }, [
        endMonth,
        startMonth,
        endYear,
        startYear,
        debounce,
        endMonthChanged,
        endYearChanged,
        rangeChoiceChanged,
        reporter,
        startMonthChanged,
        startYearChanged,
    ]);
    var handleChange = function (event) {
        var value = event.target.value;
        var startValues = utils.getStartValues(value);
        setRangeChoice(value);
        setStartMonth(startValues.month);
        setStartYear(startValues.year);
        setEndMonth(currentMonth);
        setEndYear(currentYear);
    };
    var possibleYears = utils.buildPossibleYears(currentYear);
    var handleStartMonthChange = function (event) {
        setStartMonth(event.target.value);
        setRangeChoice('custom');
    };
    var handleStartYearChange = function (event) {
        setStartYear(event.target.value);
        setRangeChoice('custom');
    };
    var handleEndMonthChange = function (event) {
        setEndMonth(event.target.value);
        setRangeChoice('custom');
    };
    var handleEndYearChange = function (event) {
        setEndYear(event.target.value);
        setRangeChoice('custom');
    };
    var monthValues = Object.values(constants.Months).map(function (key) { return fm({ id: key }); });
    return (React__default.createElement(styledComponents.Main, null,
        React__default.createElement(styledComponents.MarginRightInputLabel, null,
            Translations.date,
            ":"),
        React__default.createElement(RangeSelector, { rangeChoice: rangeChoice, handleChange: handleChange }),
        React__default.createElement(styledComponents.StyledInputLabel, null,
            Translations.start,
            ":"),
        React__default.createElement(StartMonthSelect, { months: monthValues, startMonth: startMonth, handleStartMonthChange: handleStartMonthChange, endYear: endYear, endMonth: endMonth, startYear: startYear }),
        React__default.createElement(StartYearSelect, { endYear: endYear, handleStartYearChange: handleStartYearChange, possibleYears: possibleYears, startYear: startYear }),
        React__default.createElement(styledComponents.StyledInputLabel, null,
            Translations.end,
            ":"),
        React__default.createElement(EndMonthSelect, { months: monthValues, startMonth: startMonth, handleEndMonthChange: handleEndMonthChange, endYear: endYear, endMonth: endMonth, startYear: startYear }),
        React__default.createElement(EndYearSelect, { endYear: endYear, handleEndYearChange: handleEndYearChange, possibleYears: possibleYears, startYear: startYear })));
};

module.exports = MonthYearRangePicker;
